import _t from "../models/identifier.js";
import { getByteLength as U } from "../util/string-utils.js";
import ti from "../models/push-token.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as i } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
export default class bt {
  constructor(t, s) {
    (this.yt = t), (this.u = s), (this.yt = t), (this.u = s);
  }
  getUserId() {
    const t = this.u.tu(i.eu.su);
    if (null == t) return null;
    let s = t.iu,
      e = U(s);
    if (e > User.lr) {
      for (; e > User.lr; ) (s = s.slice(0, s.length - 1)), (e = U(s));
      (t.iu = s), this.u.uu(i.eu.su, t);
    }
    return s;
  }
  ru(t) {
    const s = null == this.getUserId();
    this.u.uu(i.eu.su, new _t(t)), s && this.u.ou(t);
  }
  setCustomUserAttribute(t, s) {
    if (this.yt.hu(t))
      return (
        r.j.info('Custom Attribute "' + t + '" is blocklisted, ignoring.'), !1
      );
    const e = {};
    return (e[t] = s), this.nu(User.lu, e, !0);
  }
  nu(t, s, e = !1, i = !1) {
    const u = this.u.mu(this.getUserId(), t, s);
    let o = "",
      h = t,
      n = s;
    return (
      e &&
        ((o = " custom"),
        "object" == typeof s &&
          ((h = Object.keys(s)[0]),
          (n = s[h]),
          "object" == typeof n && (n = JSON.stringify(n, null, 2)))),
      !i && u && r.j.info(`Logged${o} attribute ${h} with value ${n}`),
      u
    );
  }
  _n(t, s, e, u, o) {
    this.nu("push_token", t, !1, !0),
      this.nu("custom_push_public_key", e, !1, !0),
      this.nu("custom_push_user_auth", u, !1, !0),
      this.nu("custom_push_vapid_public_key", o, !1, !0);
    const h = r.ts.Zt,
      n = new r.es(h, r.j),
      l = new ti(t, s, e, u, o);
    this.u.D(i.k.Bn, l.tt()), n.setItem(h.rs.cu, h.ie, !0);
  }
  Nn(t) {
    if (
      (this.nu("push_token", null, !1, !0),
      this.nu("custom_push_public_key", null, !1, !0),
      this.nu("custom_push_user_auth", null, !1, !0),
      this.nu("custom_push_vapid_public_key", null, !1, !0),
      t)
    ) {
      const t = r.ts.Zt,
        s = new r.es(t, r.j);
      this.u.D(i.k.Bn, !1), s.setItem(t.rs.cu, t.ie, !1);
    }
  }
}
